export function UnknownTenant() {
  return (
    <main className="unknown-tenant" data-testid="unknown-tenant">
      <h1>SailPlot</h1>
      <p>This SailPlot domain is not configured.</p>
    </main>
  );
}
